module.exports = __webpack_public_path__ + "static/media/image1.a9f65b19.PNG";